<template>
  <div id="BnpTab">
    <div>
      <b-tabs active-nav-item-class="font-weight-bold  text-info">
          <b-tab lazy v-for="(item, index) in tab" :key="index" :active="item.active" :title="item.header">
            <slot :name="'content' + index"> </slot>
          </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [],
      tabCounter: 0,
    }
  },
  props: {
    tab: { type: Array, default: [] },
  },
}
</script>
<style scoped></style>
